/**
 * Language Switcher functionality
 */

/** Keys used by catalog-filters.js for back-navigation restore; HTML includes translated labels. */
window.carbuyClearCatalogSessionStorage = function () {
    try {
        [
            'catalogCarsHtml',
            'catalogFilters',
            'catalogPage',
            'catalogHasMore',
            'catalogScroll',
            'catalogContentLang'
        ].forEach(function (k) {
            sessionStorage.removeItem(k);
        });
    } catch (e) {}
};

document.addEventListener('DOMContentLoaded', function() {
    
    // Handle language dropdown clicks
    const languageLinks = document.querySelectorAll('.header-single-language-link');
    
    languageLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const href = this.getAttribute('href');
            
            // Show loading state (optional)
            const currentLangButton = document.querySelector('.header-languages-link');
            if (currentLangButton) {
                currentLangButton.style.opacity = '0.6';
            }

            // Catalog list cache is locale-specific (translated gearbox, colors, etc.)
            if (typeof window.carbuyClearCatalogSessionStorage === 'function') {
                window.carbuyClearCatalogSessionStorage();
            }
            
            // Navigate to language switch URL
            window.location.href = href;
        });
    });
    
    // Update current language display
    function updateLanguageDisplay() {
        const currentLang = document.documentElement.lang || 'lv';
        const currentLangButton = document.querySelector('.header-languages-link');
        
        if (currentLangButton) {
            currentLangButton.textContent = currentLang.toUpperCase();
        }
        
        // Update active state in dropdown
        languageLinks.forEach(function(link) {
            const linkLang = link.textContent.toLowerCase();
            if (linkLang === currentLang) {
                link.classList.add('active-dropdown-item');
            } else {
                link.classList.remove('active-dropdown-item');
            }
        });
    }
    
    // Initialize language display
    updateLanguageDisplay();
    
}); 